// "Show in pocket listings" switch on pipeline records (Seller, Buyer, Landlord, Tenant).
// The record field is showInPocketListings (true/false). When it was never set, the default keeps the
// old behavior so nothing disappears: seller-style records (Seller/Landlord) show, buyer-style records
// (Buyer/Tenant) do not. Converted records never show. The mirror row is abbreviated: no client name,
// address, phone, email, notes or estimated price.
function pocketDefault(kind) { return kind !== 'buyer'; }
function showsInPocketListings(record, kind) {
  if (!record) return false;
  if (record.status === 'Converted' || record.convertedTransactionId) return false;
  if (record.showInPocketListings === true || record.showInPocketListings === false) return record.showInPocketListings;
  return pocketDefault(kind);
}
function pocketTypeLabel(record, kind) {
  const t = Array.isArray(record && record.pipelineTypes) ? record.pipelineTypes : [];
  if (kind === 'buyer') return t.includes('Tenant') && !t.includes('Buyer') ? 'Tenant' : 'Buyer';
  return t.includes('Landlord') && !t.includes('Seller') ? 'Landlord' : 'Seller';
}
function toPocketRow(record, kind, agent, nowIso) {
  const r = record || {};
  const buyer = kind === 'buyer';
  return {
    ...(buyer ? { buyerInterestId: r.id || '' } : { sellerInterestId: r.id || '' }),
    kind: buyer ? 'buyer' : 'seller', type: pocketTypeLabel(r, kind),
    community: (buyer ? r.areas : r.community) || '', floorPlan: (buyer ? r.propertyType : r.floorPlan) || '',
    pool: (buyer ? (r.poolRequired === 'Yes' ? 'Yes' : '') : r.pool) || '', view: buyer ? '' : (r.view || ''),
    priceMin: r.priceMin || '', priceMax: r.priceMax || '',
    agentId: (agent && agent.uid) || '', agentName: (agent && agent.name) || '',
    agentContact: { phone: (agent && agent.phone) || '', email: (agent && agent.email) || '' },
    updatedAt: nowIso || new Date().toISOString(),
  };
}
module.exports = { pocketDefault, showsInPocketListings, toPocketRow, pocketTypeLabel };
